import * as React from "react";
import { render } from "react-dom";
import { ReactMultiEmail } from "react-multi-email";
import "react-multi-email/style.css";
import { withStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
    root: {
        position:'relative',
        "& .react-multi-email":{
            overflowY:'scroll',
            height:'40px',
        }
    },
    label:{
        position:'absolute',
        zIndex:1,
        top: '-9px',
        left: '7px',
        background: 'white',
        padding: '0 7px',
    }
});

interface IProps {}
interface IState {
    emails: string[];
}

class MultipleEmail extends React.Component<IProps, IState> {

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <Box className={classes.label}>
                    <Typography variant="caption" >
                        <Box color="text.secondary">
                            {this.props.label}{this.props.required?<Box component={'span'} style={{color:'red'}}> *</Box>:""}
                        </Box>
                    </Typography>
                </Box>
                <ReactMultiEmail
                    placeholder="Input your Email Address"
                    emails={this.props.value}
                    onChange={this.props.change}
                    getLabel={(
                        email: string,
                        index: number,
                        removeEmail: (index: number) => void
                    ) => {
                        return (
                            <div data-tag key={index}>
                                {email}
                                <span data-tag-handle onClick={() => removeEmail(index)}>×</span>
                            </div>
                        );
                    }}
                />
            </div>
        );
    }
}

export default withStyles(styles)(MultipleEmail);
